import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import NavIconLogout from './nav-icon-logout.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <NavIconLogout {...validProps} />;
}
SvgComponent.iconName = 'navIconLogout';

/**
 * @deprecated This is a legacy icon
 */
export const NavIconLogoutIcon = svgIconWrapper(SvgComponent);
